import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from '../../../../../../core/service/v2/abstractRepositoryV2';
import { TreatmentFeedbackModel } from '../../../api/models/treatment-feedback.model';

@Injectable()
export class TreatmentFeedbackRepository extends AbstractRepositoryV2<TreatmentFeedbackModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('TreatmentFeedback', serviceElementsFactory, injector);
    }
}
